import { api } from 'api';
import { ApButtonCasual } from 'components/UIComponents/Buttons';

import './SettlementAgreemantGetTemplate.css';

interface Props {}

export const SettlementAgreemantGetTemplate = (props: Props) => {
  const handleSampleClick = () => api.settlementAgreementTemplates.downloadSample();

  return (
    <div className="settlement-agreement-get-template">
      <div>
        The Agreement Template represents the structure of the official settlement
        agreement. This document merges into one file the following:
        <ul>
          <li> Cover Letter </li>
          <li> Settlement Agreement </li>
          <li> Signature Page </li>
          <li> Exhibit Page(s) </li>
        </ul>
      </div>

      <div>
        This file will be populated with specific data for each claim and should be
        sent out to the Clients and Counterparties for signing.
      </div>

      <h4>
        You can create a new Agreement Template by starting with our standard
        agreement file.{' '}
      </h4>
      <ApButtonCasual onClick={handleSampleClick}>
        Download A Standard Agreement Template
      </ApButtonCasual>
    </div>
  );
};
